import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'reactstrap';
import { find, orderBy } from 'lodash';
import moment from 'moment';

const TankCurrentLotCard = ({ currentLot }) => {
  if (!currentLot) {
    return null;
  }

  const { id, reference, transfers, startDate, isConsolidated, status } = currentLot;
  const nextNonPendingTransfer =
    status !== 'COMPLETED' && find(orderBy(transfers, ['transferDate']), t => t.status !== 'COMPLETED');

  return (
    <Card className="mt4 pa3">
      <h3 className="f3 strong mt0">Currently brewing</h3>
      <p>
        <Link to={`/lots/${id}`}>{reference}</Link>
      </p>
      {isConsolidated && (
        <Fragment>
          <h4 className="table-header mv0">Consolidated</h4>
          <p>This is a consolidated lot.</p>
        </Fragment>
      )}
      <h4 className="table-header mv0">Started</h4>
      <p>
        This lot was started {moment(startDate).fromNow()} ({moment(startDate).format('dddd Do MMMM')})
      </p>
      {nextNonPendingTransfer && (
        <Fragment>
          <h4 className="table-header mv0">Next transfer</h4>
          <p>
            <strong>{nextNonPendingTransfer.name}</strong> {moment(nextNonPendingTransfer.transferDate).fromNow()}
          </p>
        </Fragment>
      )}
    </Card>
  );
};

export default TankCurrentLotCard;



// WEBPACK FOOTER //
// ./src/components/tankCurrentLotCard/tankCurrentLotCard.jsx